import { render } from "./EditTags.vue?vue&type=template&id=16c16da6&scoped=true&ts=true"
import script from "./EditTags.vue?vue&type=script&lang=ts"
export * from "./EditTags.vue?vue&type=script&lang=ts"

import "./EditTags.vue?vue&type=style&index=0&id=16c16da6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c16da6"]])

export default __exports__